/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';

import { connect, useSelector } from 'react-redux';
import API from 'constants/api';

import EditObject from './EditObject';

import { getUnsavedChanges } from 'validation/objectValidation';
import { setActiveTab, getObject, resetState } from 'actions/objectActions';

const EditView = ({ uri, view, parentUri, getUnsavedChanges, getObject, 
  setActiveTab, resetState }) => {
  const activeTab = useSelector(state => state.object.activeTab);
  const tabs = useSelector(state => state.object.tabs);

  useEffect(() => {
    // eslint-disable-next-line no-undef
    MetadataView.getMetadataInputChanges = () => getUnsavedChanges();
    let windowId = sessionStorage.getItem("WINDOW_ID");
    getObject(`${API.UI.EDIT_OBJECT}&uri=${uri}&windowId=${windowId}`)
      .then(() => window.parent?.reloadTree(parentUri));
    return () => resetState();
  }, []);

  return <EditObject 
    tabs={tabs} 
    view={view}
    uri={uri}
    active={activeTab} 
    setActive={setActiveTab} />;
};

export default connect(null, { getUnsavedChanges, getObject, 
  setActiveTab, resetState })(EditView);